import React from 'react';
import { connect } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

// Components - Atoms, Molecules, Organisms, Pages
import SessionTimeout from './SessionTimeout';
import APBackdropLoader from '../components/atoms/APBackdropLoader';
// Redux
import { RemoveAllAuthCookie } from '../redux/modules/user/actions';
import { actions as UserActions } from '../redux/modules/user';
import { ReducerState } from './../redux/modules';

const PrivateRoute: React.FC = (props: any) => {
  const { isAuthenticated, loadingState, resetUserDetailsStates, affiliateLoadingState } = props;

  const isAuthLoading = loadingState === 'LOADING';
  const isAffiliateDetailsLoading = affiliateLoadingState === 'LOADING';

  React.useEffect(() => {
    if (!isAuthenticated && loadingState !== 'LOADING') {
      RemoveAllAuthCookie();
      resetUserDetailsStates();
    }
  }, [isAuthenticated, loadingState, resetUserDetailsStates]);

  if (isAuthLoading || isAffiliateDetailsLoading) {
    return <APBackdropLoader open />;
  }

  if (!isAuthenticated && loadingState !== 'LOADING') {
    return <Navigate to="/login" />;
  }

  return <SessionTimeout component={<Outlet />} />;
};

const mapStateToProps = (store: ReducerState) => ({
  isAuthenticated: store.user.isAuthenticated,
  affiliateLoadingState: store.user.affiliateLoadingState,
  loadingState: store.user.loadingState,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  resetUserDetailsStates: UserActions.resetUserDetailsStates,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
